'use strict';

import {checklistsModel} from "../../models/checklistsmodel.js";

export class ChecklistsCtrl
{
//	$scope;
//	$filter;
//	$timeout;
//	jsDataService;
//	notify;

//	showRequire = false;
//	
	constructor($scope, $filter, $timeout, $mdDialog, jsDataService, notify){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.notify = notify;
		this.$mdDialog = $mdDialog;
		this.$timeout = $timeout;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.postConstruct();
	}
	postConstruct(){
		let evaluation = this.jsDataService.get('evaluation', {});
		this.evaluation = new checklistsModel(evaluation, this.$filter, this.jsDataService);
	}
	
	getCriteria(){
		return this.evaluation.data_value.getCriteriaList();
	}

	getCriteriaNoHidden(){
		return this.evaluation.data_value.getCriteriaListNoHidden();
	}
	
	autosavePostFields(){
//		let post = this.evaluation.data_value.questions;
		return {
			criteria: this.evaluation.data_value.getCriteriaData(),
			projectGrantAmountRequested: this.evaluation.data_value.projectGrantAmountRequested,
			projectGrantAmountProposed: this.evaluation.data_value.projectGrantAmountProposed,
			projectGrantAmountFinal: this.evaluation.data_value.projectGrantAmountFinal
		};
	}
	
	confirmEvaluation(ev, form){
		this.showRequire = true;
		this.$timeout(()=>{
			if(form.$invalid){
				this.notify(this.$filter('tr')('err_check_required_fields'), true);
			}
			else{
				const confirmTexts = this.jsDataService.get('evaluationConfirmTexts');
				const confirm = this.$mdDialog.confirm()
					.title(confirmTexts.title)
					.htmlContent(confirmTexts.content)
					.ariaLabel(confirmTexts.title)
					.targetEvent(ev)
					.ok(confirmTexts.ok)
					.cancel(confirmTexts.cancel);
				this.$mdDialog.show(confirm).then(() => {
					this.$scope.basicHttpConfigProcess({
						url: this.jsDataService.get('cfgConfirmUrl'),
						method: 'GET',
						params: {}
					}).then((results) => {
						if(results.data.success){

						}
					});
				}, () => {});
			}
		});
		
	}

	completeEvaluation(ev){
		this.$timeout(()=>{
			const confirmTexts = this.jsDataService.get('evaluationCompleteTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgCompleteUrl'),
					method: 'GET',
					params: {}
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});			
			
		});		
	}
	
	completeDialogCtrl($scope, $mdDialog) {
		$scope.comment = '';
		$scope.close = function () {
			$mdDialog.cancel();
		};

		$scope.submitDialog = function () {
			$mdDialog.hide({
				comment: $scope.comment
			});
		};
	}
	
	cancelEvaluation(ev){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", this.completeDialogCtrl],
			templateUrl: 'contracts/evaluation_return.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true
//				locals: {
//					evaluation: this.evaluation
//				}
		}).then((results) => {
			const url = this.jsDataService.get('cfgCancelUrl');
			if (url) {
				this.$scope.basicHttpConfigProcess({
					url: url,
					method: 'POST',
					data: results
				});
			}
		}, () => {
		});

	}
	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}
}